<template>
  <div class="exam-list">
    <section class="search-form">
      <el-form
        inline
        :model="searchData"
        ref="searchForm"
      >
        <el-form-item
          label="题目名称"
          prop="questionName"
          :rules="{validator: validateName}"
        >
          <el-input v-model="searchData.questionName"></el-input>
        </el-form-item>
        <el-form-item label="题目类型">
          <el-select
            v-model="searchData.questionType"
            clearable
          >
            <el-option
              v-for="questionType in questionTypeList"
              :key="questionType.value"
              :label="questionType.label"
              :value="questionType.value"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <footer class="flex-between">
        <div>
          <el-button
            type="primary"
            size="small"
            @click="handleSearchClick"
          >查询</el-button>
          <el-button
            size="small"
            @click="handleResetClick"
          >清空查询条件</el-button>
        </div>
        <div>
          <el-button
            size="small"
            @click="visibleAdd = true"
            v-if="functionList.includes('327311471939391488')"
          >新增题目</el-button>
        </div>
      </footer>
    </section>
    <el-table
      border
      :data="tableData"
    >
      <template slot="empty">
        {{emptyText}}
      </template>
      <el-table-column
        v-for="col in tableLabelList"
        :key="col.prop"
        :label="col.label"
        :prop="col.prop"
        :formatter="formatter"
        :min-width="col.width"
      />
      <el-table-column
        fixed="right"
        width="130"
        label="操作"
      >
        <template slot-scope="scope">
          <div class="feature-container">
            <span
              class="button--blue"
              @click="handleStatusClick(scope.row)"
              v-if="functionList.includes('327312285156216832')"
            >{{scope.row.questionStatus === '0' ? '启用':'禁用'}}</span>
            <span
              class="button--blue"
              v-if="functionList.includes('327312023360344064')"
              @click="handleEditClick(scope.row)"
            >编辑</span>
            <span
              v-if="functionList.includes('327312503075475456')"
              class="button--red"
              @click="handleDeleteClick(scope.row)"
            >删除</span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <yh-pagination
      :page.sync="currentPage"
      :total="sumCount"
    />
    <yh-dialog
      title="新增题目"
      :visible.sync="visibleAdd"
    >
      <el-form
        inline
        :model="addData"
        ref="addForm"
      >
        <el-form-item
          label="题目类型"
          prop="questionType"
          required
        >
          <el-radio
            v-for="item in questionTypeList"
            :key="item.value"
            :label="item.value"
            v-model="addData.questionType"
          >{{item.label}}</el-radio>
        </el-form-item>
        <el-form-item
          label="题目名称"
          prop="questionName"
          :rules="[{required: true, message: $MSG.M0140}, {validator: validateName}]"
          required
        >
          <el-input
            v-model="addData.questionName"
            placeholder="请输入题目名称，不超过100字"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="题目答案"
          prop="questionChoiceSaveDtoList"
          :rules="[{required: true, message: $MSG.M0140}, {validator: limitAnswerList}]"
        >
          <yh-button
            @click="handleAddAnswerClick"
            size="small"
            style="width: 320px"
          >添加答案</yh-button>
        </el-form-item>
        <div
          class="no-answer"
          v-show="!addData.questionChoiceSaveDtoList.length"
        >暂无数据</div>
        <div class="answer-container">
          <div
            class="answer-card"
            v-for="(item, index) in addData.questionChoiceSaveDtoList"
            :key="item.fid"
          >
            <el-form-item
              :label="getCode(index)"
              :prop="'questionChoiceSaveDtoList.' + index + '.choiceContent'"
              :rules="[{
              required: true, message: $MSG.M0140
            }, {
              validator: validateAnswer
            }]"
            >
              <el-input
                v-model="item.choiceContent"
                placeholder="请填写题目答案"
                autosize
                type="textarea"
              ></el-input>
            </el-form-item>
            <el-form-item
              v-if="visibleScore"
              @change.native="limitScore(item, 'choiceScore')"
              required
              label="分值"
              :prop="'questionChoiceSaveDtoList.' + index +'.choiceScore'"
              :rules="[{
              required : true, message: $MSG.M0140,
            }]"
            >
              <el-input
                v-model="item.choiceScore"
                placeholder="请填写题目分值，分值为整数"
              ></el-input>
            </el-form-item>
            <p style="text-align: right;"><span
                class="button--blue"
                @click.stop="handleRemoveClick(item, 'addData')"
              >删除</span></p>
          </div>
        </div>
      </el-form>
      <div slot="footer">
        <el-button @click="visibleAdd=false">取消</el-button>
        <el-button
          @click="handleComfirmAdd"
          type="primary"
        >新增题目</el-button>
      </div>
    </yh-dialog>
    <yh-dialog
      title="编辑题目"
      :visible.sync="visibleEdit"
    >
      <el-form
        inline
        :model="editData"
        ref="editForm"
      >
        <el-form-item
          label="题目类型"
          prop="questionType"
          required
        >
          <el-radio
            v-for="item in questionTypeList"
            :key="item.value"
            :label="item.value"
            v-model="editData.questionType"
          >{{item.label}}</el-radio>
        </el-form-item>
        <el-form-item
          label="题目名称"
          prop="questionName"
          :rules="[{required: true, message: '题目名称不能为空'}, {validator: validateName}]"
          required
        >
          <el-input
            v-model="editData.questionName"
            placeholder="请输入题目名称，不超过100字"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="题目答案"
          prop="questionChoiceSaveDtoList"
          :rules="[{required: true, message: $MSG.M0140},{validator: limitAnswerList}]"
        >
          <yh-button
            @click="handleAddEditClick"
            size="small"
            style="width: 320px"
          >添加答案</yh-button>
        </el-form-item>
        <div
          class="no-answer"
          v-show="!editData.questionChoiceSaveDtoList.length"
        >暂无数据</div>
        <div class="answer-container">
          <div
            class="answer-card"
            v-for="(item, index) in editData.questionChoiceSaveDtoList"
            :key="item.fid"
          >
            <el-form-item
              :label="getCode(index)"
              :prop="'questionChoiceSaveDtoList.' + index + '.choiceContent'"
              :rules="[{
              required: true, message: $MSG.M0140
            }, {
              validator: validateAnswer
            }]"
            >
              <el-input
                v-model="item.choiceContent"
                placeholder="请填写题目答案"
                autosize
                type="textarea"
              ></el-input>
            </el-form-item>
            <el-form-item
              v-if="visibleEditScore"
              @change.native="limitScore(item, 'choiceScore')"
              required
              label="分值"
              :prop="'questionChoiceSaveDtoList.' + index +'.choiceScore'"
              :rules="[{
              required : true, message: $MSG.M0140,
            }]"
            >
              <el-input
                v-model="item.choiceScore"
                placeholder="请填写题目分值，分值为整数"
              ></el-input>
            </el-form-item>
            <p style="text-align: right;"><span
                class="button--blue"
                @click.stop="handleRemoveClick(item, 'editData')"
              >删除</span></p>
          </div>
        </div>
      </el-form>
      <div slot="footer">
        <el-button @click="visibleEdit=false">取消</el-button>
        <el-button
          @click="handleComfirmUpdate"
          type="primary"
        >保存</el-button>
      </div>
    </yh-dialog>
  </div>
</template>
<script>
import { getPagingData, getFunctionList } from '@/mixins';

const { userId } = JSON.parse(sessionStorage.getItem('sessionData'));
const baseData = {
  questionType: '0',
  questionName: '',
  questionStatus: '1',
  createId: userId,
  updateId: userId,
  questionChoiceSaveDtoList: [],
};
export default {
  name: 'ExamList',
  mixins: [getPagingData, getFunctionList],

  data() {
    return {
      visibleAdd: false,
      visibleEdit: false,
      functionList: [],
      currentPage: 1,
      sumCount: 0,
      emptyText: this.$LS.empty,
      addData: {
        ...baseData,
        questionChoiceSaveDtoList: [],
      },
      editData: {
        ...baseData,
        questionChoiceSaveDtoList: [],
      },
      searchParam: {
        questionName: '',
        questionType: '',
      },
      searchData: {
        questionName: '',
        questionType: '',
      },
      questionTypeList: [{
        value: '0',
        label: '单选',
      }, {
        value: '1',
        label: '多选',
      }],
      questionTypeMap: {
        0: '单选',
        1: '多选',
      },
      questionStatusMap: {
        0: '禁用',
        1: '启用',
      },
      tableLabelList: [{
        label: '题目ID',
        prop: 'id',
        width: 200,
      }, {
        label: '题目名称',
        prop: 'questionName',
        width: 200,
      }, {
        label: '题目类型',
        prop: 'questionType',
        width: 200,
      }, {
        label: '分值区间',
        prop: 'scoreSpace',
        width: 200,
      }, {
        label: '状态',
        prop: 'questionStatus',
        width: 200,
      }, {
        label: '创建时间',
        prop: 'createTime',
        width: 200,
      }, {
        label: '创建人ID',
        prop: 'createId',
        width: 200,
      }, {
        label: '修改时间',
        prop: 'updateTime',
        width: 200,
      }, {
        label: '修改人ID',
        prop: 'updateId',
        width: 200,
      }],
    };
  },
  computed: {
    searchForm() {
      return this.$refs.searchForm;
    },
    addForm() {
      return this.$refs.addForm;
    },
    editForm() {
      return this.$refs.editForm;
    },
    visibleScore() {
      return this.addData.questionType === '0';
    },
    visibleEditScore() {
      return this.editData.questionType === '0';
    },
  },
  watch: {
    'addData.questionType': function watchTypeChange() {
      const list = this.addData.questionChoiceSaveDtoList;
      this.addData.questionChoiceSaveDtoList = list.map(answer => ({
        ...answer,
        choiceScore: 0,
      }));
    },
    'editData.questionType': function watchTypeChange() {
      const list = this.editData.questionChoiceSaveDtoList;
      this.editData.questionChoiceSaveDtoList = list.map(answer => ({
        ...answer,
        choiceScore: 0,
      }));
    },
    'addData.questionChoiceSaveDtoList': function validateField() {
      this.$nextTick(() => this.addForm.validateField('questionChoiceSaveDtoList'));
    },
    'editData.questionChoiceSaveDtoList': function validateField() {
      this.$nextTick(() => this.editForm.validateField('questionChoiceSaveDtoList'));
    },
    currentPage: {
      immediate: true,
      handler() {
        this.listQuestion();
      },
    },
    visibleAdd(v) {
      if (!v) {
        this.addForm.clearValidate();
        this.addData = { ...baseData, questionChoiceSaveDtoList: [] };
      }
    },
    visibleEdit(v) {
      if (!v) {
        this.editForm.clearValidate();
        this.editData = { ...baseData, questionChoiceSaveDtoList: [] };
      }
    },
  },
  methods: {
    limitScore(data, key) {
      // eslint-disable-next-line no-param-reassign
      data[key] = data[key].replace(/[^\d-]/g, '');
      if (data[key].indexOf('-') !== 0) {
        // eslint-disable-next-line no-param-reassign
        data[key] = data[key].replace('-', '');
      }
      if (data[key] < -999999) {
        // eslint-disable-next-line no-param-reassign
        data[key] = data[key].slice(0, 7);
      }
      if (data[key] > 999999) {
        // eslint-disable-next-line no-param-reassign
        data[key] = data[key].slice(0, 6);
      }
    },
    formatter(row, col, value) {
      if (col.property === 'questionType') {
        return this.questionTypeMap[value] || '-';
      }
      if (col.property === 'questionStatus') {
        return this.questionStatusMap[value] || '-';
      }
      return value || '-';
    },
    validateName(rule, value, cb) {
      if (value.length > 100) {
        cb(this.$MSG.M0124);
      } else {
        cb();
      }
    },
    listQuestion() {
      function transformList(list) {
        return list.map(item => ({
          ...item,
          scoreSpace: `${item.questionMin}-${item.questionMax}`,
        }));
      }
      this.getPagingData(this.$API.listQuestion, transformList);
    },
    validateAnswer(rule, value, cb) {
      if (value.length > 100) {
        cb(this.$MSG.M0126);
      } else {
        cb();
      }
    },
    checkData() {
      this.addForm.validate((valid) => {
        if (valid) {
          this.postQuestion();
        }
      });
    },
    handleComfirmAdd() {
      this.checkData();
    },
    handleRemoveClick(item, name) {
      const index = this[name].questionChoiceSaveDtoList.indexOf(item);
      if (index > -1) {
        this[name].questionChoiceSaveDtoList.splice(index, 1);
      }
    },
    postQuestion() {
      this.$_post(this.$API.postQuestion, {
        data: {
          ...this.addData,
        },
      }).then((res) => {
        if (res.errorCode === this.$CODE.success) {
          this.$message.success(this.$MSG.M0128);
          this.listQuestion();
          this.visibleAdd = false;
        } else if (res.errorCode === this.$CODE.duplicatedQuestion) {
          this.$message.warning(this.$MSG.M0127);
        } else {
          this.$message.warning(res.errorMsg);
        }
      });
    },
    getCode(code) {
      return String.fromCharCode(code + 65);
    },
    limitAnswerList(rule, value, cb) {
      if (value.length > 15) {
        cb(this.$MSG.M0125);
      } else {
        cb();
      }
    },
    handleAddAnswerClick() {
      this.addData.questionChoiceSaveDtoList.push({
        fid: Date.now(),
        choiceScore: this.visibleScore ? '' : '0',
        choiceContent: '',
      });
    },
    handleAddEditClick() {
      this.editData.questionChoiceSaveDtoList.push({
        fid: Date.now(),
        choiceScore: this.visibleEditScore ? '' : '0',
        choiceContent: '',
      });
    },
    handleSearchClick() {
      this.searchForm.validate((valid) => {
        if (valid) {
          this.searchParam = { ...this.searchData };
          this.listQuestion();
        }
      });
    },
    handleResetClick() {
      Object.keys(this.searchData).forEach((key) => {
        this.searchData[key] = '';
        this.searchParam[key] = '';
      });
    },
    handleEditClick(row) {
      this.$_post(this.$API.checkQuestion, {
        data: {
          id: row.id,
        },
      }).then((res) => {
        if (res.errorCode === this.$CODE.success) {
          if (res.data.count === 0) {
            return this.listQuestionChoice(row);
          }
        }
        return this.$message.warning(this.$MSG.M0131);
      });
    },
    handleStatusClick(row) {
      if (row.questionStatus === '0') {
        this.$_yh_confirm('确定启用题目', '启用题目').then(() => this.updateQuestionStatus(row));
      } else {
        this.$_yh_confirm('确定禁用题目', '禁用题目').then(() => this.updateQuestionStatus(row));
      }
    },
    listQuestionChoice(row) {
      this.$_post(this.$API.listQuestionChoice, {
        data: {
          questionId: row.id,
        },
      }).then((res) => {
        if (res.errorCode === this.$CODE.success) {
          this.editData = {
            ...row,
            questionChoiceSaveDtoList: res.data.list,
          };
          this.visibleEdit = true;
        }
      });
    },
    updateQuestionStatus(row) {
      const swap = {
        0: '1',
        1: '0',
      };
      const msg = {
        0: this.$MSG.M0197,
        1: this.$MSG.M0198,
      };
      return this.$_post(this.$API.updateQuestionStatus, {
        data: {
          id: row.id,
          questionStatus: swap[row.questionStatus],
          updateId: baseData.createId,
        },
      }).then((res) => {
        if (res.errorCode === this.$CODE.success) {
          this.$message.success(msg[row.questionStatus]);
          this.listQuestion();
        } else {
          this.$message.warning(res.errorMsg);
        }
      });
    },
    handleComfirmUpdate() {
      this.editForm.validate((valid) => {
        if (valid) {
          this.updateQuestion();
        }
      });
    },
    updateQuestion() {
      return this.$_post(this.$API.updateQuestion, {
        data: {
          ...this.editData,
        },
      }).then((res) => {
        if (res.errorCode === this.$CODE.success) {
          this.$message.success(this.$MSG.M0201);
          this.listQuestion();
          this.visibleEdit = false;
        } else if (res.errorCode === this.$CODE.duplicatedQuestion) {
          this.$message.warning(this.$MSG.M0127);
        } else {
          this.$message.warning(res.errorMsg);
        }
      });
    },
    handleDeleteClick(row) {
      this.$_yh_confirm('确定删除题目，已添加至问卷的题目无法删除', '删除题目').then(() => {
        this.deleteQuestion(row.id);
      });
    },
    deleteQuestion(id) {
      this.$_post(this.$API.deleteQuestion, {
        data: {
          id,
          updateId: baseData.createId,
        },
      }).then((res) => {
        if (res.errorCode === this.$CODE.success) {
          this.$message.success(this.$MSG.M0129);
          this.listQuestion();
        } else {
          this.$message.warning(this.$MSG.M0130);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.answer-card {
  background-color: #f6f6f6;
  padding-top: 20px;
  padding-bottom: 20px;
  margin-bottom: 20px;
  .el-input {
    width: 300px;
  }
  .el-textarea {
    width: 300px;
  }
}
.no-answer {
  text-align: center;
  color: #909399;
}
.answer-container {
  max-height: 500px;
  overflow: auto;
}
</style>
<style lang="scss">
.exam-list {
  .yh-dialog .el-form-item__error {
    width: 300px !important;
  }
}
</style>
